export const BASE_URL = '/api/v1';
export const BASE_URL_V2 = '/api/v2';
export const BASE_URL_V2_1 = '/api/v2.1';
export const BASE_URL_V3 = '/api/v3';
export const LEARNOSITY_QUESTIONS_API =
  'https://questions-ie.learnosity.com/?v2024.3.LTS';
export const LEARNOSITY_QUESTIONS_API_FALLBACK =
  'https://questions.learnosity.com/?v2024.3.LTS';
export const LEAP_APP_CODE = 999999;
